import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { NoticeService } from '@df/ui/api/notice/notice.service';
import { TranslationNoticeService } from '@df/ui/translation/translation-notice.service';

export function provideDfUiTranslation(): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: NoticeService,
            useExisting: TranslationNoticeService
        }
    ]);
}
